module.exports = __webpack_public_path__ + "img/img22.25a90512.png";